import { EntityEventsBuilder } from '@soniq/public-resource'
import {
  ContactRelationshipSchema,
  ContactSchema,
  InviteSchema,
  LocationSchema,
  ProfileSchema,
  ProfileSettingsSchema,
} from '@soniq/schema-connection'
import {
  contactRelationshipStore,
  contactStore,
  inviteStore,
  locationStore,
  profileSettingsStore,
  profileStore,
} from '@soniq/public-resource-connection'

export const contactEventsBuilder =
  EntityEventsBuilder.new<ContactSchema>(
    'contact',
    1,
    contactStore
  )

export const contactRelationshipEventsBuilder =
  EntityEventsBuilder.new<ContactRelationshipSchema>(
    'contact_relationship',
    1,
    contactRelationshipStore
  )

export const inviteEventsBuilder =
  EntityEventsBuilder.new<InviteSchema>('invite', 1, inviteStore)

export const locationEventsBuilder =
  EntityEventsBuilder.new<LocationSchema>(
    'location',
    1,
    locationStore
  )

export const profileEventsBuilder =
  EntityEventsBuilder.new<ProfileSchema>(
    'profile',
    1,
    profileStore
  )

export const profileSettingsEventsBuilder =
  EntityEventsBuilder.new<ProfileSettingsSchema>(
    'profile_settings',
    1,
    profileSettingsStore
  )
